module.exports = __webpack_public_path__ + "static/GECKO_Platform_Features-a4ec02413efc14e7d84d5f32cd1fe54c.pdf";